/* eslint-disable default-param-last */
// Action types
const SET_TABS_LIST = "spirit/utils/SET_TABS_LIST";

// InitialState
export const initialState = {
  tabsList: "1",
  tabsListRetention: "1",
};

// Reducers
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TABS_LIST:
      return {
        ...state,
        tabsList: action.info,
      };
    default:
      return state;
  }
};

// Action Creators
export const setTabsList = (info) => ({
  type: SET_TABS_LIST,
  info,
});
